/**
 * Country dial codes for phone input.
 * Format: { dialCode, name, countryCode } - countryCode is ISO 3166-1 alpha-2 for flag.
 */
export const dialCodes = [
    { dialCode: '1', name: 'Canada', countryCode: 'CA' },
    { dialCode: '1', name: 'United States', countryCode: 'US' },
    { dialCode: '1 242', name: 'Bahamas', countryCode: 'BS' },
    { dialCode: '1 246', name: 'Barbados', countryCode: 'BB' },
    { dialCode: '1 264', name: 'Anguilla', countryCode: 'AI' },
    { dialCode: '1 268', name: 'Antigua and Barbuda', countryCode: 'AG' },
    { dialCode: '1 284', name: 'British Virgin Islands', countryCode: 'VG' },
    { dialCode: '1 340', name: 'US Virgin Islands', countryCode: 'VI' },
    { dialCode: '1 345', name: 'Cayman Islands', countryCode: 'KY' },
    { dialCode: '1 441', name: 'Bermuda', countryCode: 'BM' },
    { dialCode: '1 473', name: 'Grenada', countryCode: 'GD' },
    { dialCode: '1 649', name: 'Turks and Caicos Islands', countryCode: 'TC' },
    { dialCode: '1 658', name: 'Jamaica', countryCode: 'JM' },
    { dialCode: '1 664', name: 'Montserrat', countryCode: 'MS' },
    { dialCode: '1 670', name: 'Northern Mariana Islands', countryCode: 'MP' },
    { dialCode: '1 671', name: 'Guam', countryCode: 'GU' },
    { dialCode: '1 684', name: 'American Samoa', countryCode: 'AS' },
    { dialCode: '1 721', name: 'Sint Maarten (Dutch part)', countryCode: 'SX' },
    { dialCode: '1 758', name: 'Saint Lucia', countryCode: 'LC' },
    { dialCode: '1 767', name: 'Dominica', countryCode: 'DM' },
    { dialCode: '1 784', name: 'Saint Vincent and the Grenadines', countryCode: 'VC' },
    { dialCode: '1 787', name: 'Puerto Rico', countryCode: 'PR' },
    { dialCode: '1 809', name: 'Dominican Republic', countryCode: 'DO' },
    { dialCode: '1 829', name: 'Dominican Republic', countryCode: 'DO' },
    { dialCode: '1 849', name: 'Dominican Republic', countryCode: 'DO' },
    { dialCode: '1 868', name: 'Trinidad and Tobago', countryCode: 'TT' },
    { dialCode: '1 869', name: 'Saint Kitts and Nevis', countryCode: 'KN' },
    { dialCode: '1 876', name: 'Jamaica', countryCode: 'JM' },
    { dialCode: '1 939', name: 'Puerto Rico', countryCode: 'PR' },
    { dialCode: '7', name: 'Kazakhstan', countryCode: 'KZ' },
    { dialCode: '7', name: 'Russian Federation', countryCode: 'RU' },
    { dialCode: '20', name: 'Egypt', countryCode: 'EG' },
    { dialCode: '27', name: 'South Africa', countryCode: 'ZA' },
    { dialCode: '30', name: 'Greece', countryCode: 'GR' },
    { dialCode: '31', name: 'Netherlands', countryCode: 'NL' },
    { dialCode: '32', name: 'Belgium', countryCode: 'BE' },
    { dialCode: '33', name: 'France', countryCode: 'FR' },
    { dialCode: '34', name: 'Spain', countryCode: 'ES' },
    { dialCode: '36', name: 'Hungary', countryCode: 'HU' },
    { dialCode: '39', name: 'Italy', countryCode: 'IT' },
    { dialCode: '39', name: 'Holy See (Vatican City State)', countryCode: 'VA' },
    { dialCode: '40', name: 'Romania', countryCode: 'RO' },
    { dialCode: '41', name: 'Switzerland', countryCode: 'CH' },
    { dialCode: '43', name: 'Austria', countryCode: 'AT' },
    { dialCode: '44', name: 'United Kingdom', countryCode: 'GB' },
    { dialCode: '44', name: 'Guernsey', countryCode: 'GG' },
    { dialCode: '44', name: 'Isle of Man', countryCode: 'IM' },
    { dialCode: '44', name: 'Jersey', countryCode: 'JE' },
    { dialCode: '45', name: 'Denmark', countryCode: 'DK' },
    { dialCode: '46', name: 'Sweden', countryCode: 'SE' },
    { dialCode: '47', name: 'Norway', countryCode: 'NO' },
    { dialCode: '48', name: 'Poland', countryCode: 'PL' },
    { dialCode: '49', name: 'Germany', countryCode: 'DE' },
    { dialCode: '51', name: 'Peru', countryCode: 'PE' },
    { dialCode: '52', name: 'Mexico', countryCode: 'MX' },
    { dialCode: '53', name: 'Cuba', countryCode: 'CU' },
    { dialCode: '54', name: 'Argentina', countryCode: 'AR' },
    { dialCode: '55', name: 'Brazil', countryCode: 'BR' },
    { dialCode: '56', name: 'Chile', countryCode: 'CL' },
    { dialCode: '57', name: 'Colombia', countryCode: 'CO' },
    { dialCode: '58', name: 'Venezuela', countryCode: 'VE' },
    { dialCode: '60', name: 'Malaysia', countryCode: 'MY' },
    { dialCode: '61', name: 'Australia', countryCode: 'AU' },
    { dialCode: '62', name: 'Indonesia', countryCode: 'ID' },
    { dialCode: '63', name: 'Philippines', countryCode: 'PH' },
    { dialCode: '64', name: 'New Zealand', countryCode: 'NZ' },
    { dialCode: '65', name: 'Singapore', countryCode: 'SG' },
    { dialCode: '66', name: 'Thailand', countryCode: 'TH' },
    { dialCode: '81', name: 'Japan', countryCode: 'JP' },
    { dialCode: '82', name: "Democratic People's Republic of Korea", countryCode: 'KP' },
    { dialCode: '84', name: 'Viet Nam', countryCode: 'VN' },
    { dialCode: '86', name: 'China', countryCode: 'CN' },
    { dialCode: '90', name: 'Türkiye', countryCode: 'TR' },
    { dialCode: '91', name: 'India', countryCode: 'IN' },
    { dialCode: '92', name: 'Pakistan', countryCode: 'PK' },
    { dialCode: '93', name: 'Afghanistan', countryCode: 'AF' },
    { dialCode: '94', name: 'Sri Lanka', countryCode: 'LK' },
    { dialCode: '95', name: 'Myanmar', countryCode: 'MM' },
    { dialCode: '98', name: 'Iran', countryCode: 'IR' },
    { dialCode: '211', name: 'South Sudan', countryCode: 'SS' },
    { dialCode: '212', name: 'Morocco', countryCode: 'MA' },
    { dialCode: '212', name: 'Western Sahara', countryCode: 'EH' },
    { dialCode: '213', name: 'Algeria', countryCode: 'DZ' },
    { dialCode: '216', name: 'Tunisia', countryCode: 'TN' },
    { dialCode: '218', name: 'Libya', countryCode: 'LY' },
    { dialCode: '220', name: 'Gambia', countryCode: 'GM' },
    { dialCode: '221', name: 'Senegal', countryCode: 'SN' },
    { dialCode: '222', name: 'Mauritania', countryCode: 'MR' },
    { dialCode: '223', name: 'Mali', countryCode: 'ML' },
    { dialCode: '224', name: 'Guinea', countryCode: 'GN' },
    { dialCode: '225', name: "Côte d'Ivoire", countryCode: 'CI' },
    { dialCode: '226', name: 'Burkina Faso', countryCode: 'BF' },
    { dialCode: '227', name: 'Niger', countryCode: 'NE' },
    { dialCode: '228', name: 'Togo', countryCode: 'TG' },
    { dialCode: '229', name: 'Benin', countryCode: 'BJ' },
    { dialCode: '230', name: 'Mauritius', countryCode: 'MU' },
    { dialCode: '231', name: 'Liberia', countryCode: 'LR' },
    { dialCode: '232', name: 'Sierra Leone', countryCode: 'SL' },
    { dialCode: '233', name: 'Ghana', countryCode: 'GH' },
    { dialCode: '234', name: 'Nigeria', countryCode: 'NG' },
    { dialCode: '235', name: 'Chad', countryCode: 'TD' },
    { dialCode: '236', name: 'Central African Republic', countryCode: 'CF' },
    { dialCode: '237', name: 'Cameroon', countryCode: 'CM' },
    { dialCode: '238', name: 'Cabo Verde', countryCode: 'CV' },
    { dialCode: '239', name: 'Sao Tome and Principe', countryCode: 'ST' },
    { dialCode: '240', name: 'Equatorial Guinea', countryCode: 'GQ' },
    { dialCode: '241', name: 'Gabon', countryCode: 'GA' },
    { dialCode: '242', name: 'Congo', countryCode: 'CG' },
    { dialCode: '243', name: 'Democratic Republic of the Congo', countryCode: 'CD' },
    { dialCode: '244', name: 'Angola', countryCode: 'AO' },
    { dialCode: '245', name: 'Guinea-Bissau', countryCode: 'GW' },
    { dialCode: '246', name: 'British Indian Ocean Territory', countryCode: 'IO' },
    { dialCode: '247', name: 'Ascension', countryCode: 'GB' },
    { dialCode: '248', name: 'Seychelles', countryCode: 'SC' },
    { dialCode: '249', name: 'Sudan', countryCode: 'SD' },
    { dialCode: '250', name: 'Rwanda', countryCode: 'RW' },
    { dialCode: '251', name: 'Ethiopia', countryCode: 'ET' },
    { dialCode: '252', name: 'Somalia', countryCode: 'SO' },
    { dialCode: '253', name: 'Djibouti', countryCode: 'DJ' },
    { dialCode: '254', name: 'Kenya', countryCode: 'KE' },
    { dialCode: '255', name: 'Tanzania', countryCode: 'TZ' },
    { dialCode: '256', name: 'Uganda', countryCode: 'UG' },
    { dialCode: '257', name: 'Burundi', countryCode: 'BI' },
    { dialCode: '258', name: 'Mozambique', countryCode: 'MZ' },
    { dialCode: '260', name: 'Zambia', countryCode: 'ZM' },
    { dialCode: '261', name: 'Madagascar', countryCode: 'MG' },
    { dialCode: '262', name: 'French Southern Territories', countryCode: 'TF' },
    { dialCode: '262', name: 'Reunion', countryCode: 'RE' },
    { dialCode: '262', name: 'Mayotte', countryCode: 'YT' },
    { dialCode: '263', name: 'Zimbabwe', countryCode: 'ZW' },
    { dialCode: '264', name: 'Namibia', countryCode: 'NA' },
    { dialCode: '265', name: 'Malawi', countryCode: 'MW' },
    { dialCode: '266', name: 'Lesotho', countryCode: 'LS' },
    { dialCode: '267', name: 'Botswana', countryCode: 'BW' },
    { dialCode: '268', name: 'Eswatini', countryCode: 'SZ' },
    { dialCode: '269', name: 'Comoros', countryCode: 'KM' },
    { dialCode: '290', name: 'Saint Helena and Tristan da Cunha', countryCode: 'GB' },
    { dialCode: '290', name: 'Saint Helena', countryCode: 'SH' },
    { dialCode: '291', name: 'Eritrea', countryCode: 'ER' },
    { dialCode: '297', name: 'Aruba', countryCode: 'AW' },
    { dialCode: '298', name: 'Faroe Islands', countryCode: 'FO' },
    { dialCode: '299', name: 'Greenland', countryCode: 'GL' },
    { dialCode: '350', name: 'Gibraltar', countryCode: 'GI' },
    { dialCode: '351', name: 'Portugal', countryCode: 'PT' },
    { dialCode: '352', name: 'Luxembourg', countryCode: 'LU' },
    { dialCode: '353', name: 'Ireland', countryCode: 'IE' },
    { dialCode: '354', name: 'Iceland', countryCode: 'IS' },
    { dialCode: '355', name: 'Albania', countryCode: 'AL' },
    { dialCode: '356', name: 'Malta', countryCode: 'MT' },
    { dialCode: '357', name: 'Cyprus', countryCode: 'CY' },
    { dialCode: '358', name: 'Finland', countryCode: 'FI' },
    { dialCode: '358', name: 'Aland Islands', countryCode: 'AX' },
    { dialCode: '359', name: 'Bulgaria', countryCode: 'BG' },
    { dialCode: '370', name: 'Lithuania', countryCode: 'LT' },
    { dialCode: '371', name: 'Latvia', countryCode: 'LV' },
    { dialCode: '372', name: 'Estonia', countryCode: 'EE' },
    { dialCode: '373', name: 'Moldova', countryCode: 'MD' },
    { dialCode: '374', name: 'Armenia', countryCode: 'AM' },
    { dialCode: '375', name: 'Belarus', countryCode: 'BY' },
    { dialCode: '376', name: 'Andorra', countryCode: 'AD' },
    { dialCode: '377', name: 'Monaco', countryCode: 'MC' },
    { dialCode: '378', name: 'San Marino', countryCode: 'SM' },
    { dialCode: '380', name: 'Ukraine', countryCode: 'UA' },
    { dialCode: '381', name: 'Serbia', countryCode: 'RS' },
    { dialCode: '382', name: 'Montenegro', countryCode: 'ME' },
    { dialCode: '383', name: 'Kosovo', countryCode: 'XK' },
    { dialCode: '385', name: 'Croatia', countryCode: 'HR' },
    { dialCode: '386', name: 'Slovenia', countryCode: 'SI' },
    { dialCode: '387', name: 'Bosnia and Herzegovina', countryCode: 'BA' },
    { dialCode: '389', name: 'North Macedonia', countryCode: 'MK' },
    { dialCode: '420', name: 'Czechia', countryCode: 'CZ' },
    { dialCode: '421', name: 'Slovakia', countryCode: 'SK' },
    { dialCode: '423', name: 'Liechtenstein', countryCode: 'LI' },
    { dialCode: '500', name: 'Falkland Islands', countryCode: 'FK' },
    { dialCode: '501', name: 'Belize', countryCode: 'BZ' },
    { dialCode: '502', name: 'Guatemala', countryCode: 'GT' },
    { dialCode: '503', name: 'El Salvador', countryCode: 'SV' },
    { dialCode: '504', name: 'Honduras', countryCode: 'HN' },
    { dialCode: '505', name: 'Nicaragua', countryCode: 'NI' },
    { dialCode: '506', name: 'Costa Rica', countryCode: 'CR' },
    { dialCode: '507', name: 'Panama', countryCode: 'PA' },
    { dialCode: '508', name: 'Saint Pierre and Miquelon', countryCode: 'PM' },
    { dialCode: '509', name: 'Haiti', countryCode: 'HT' },
    { dialCode: '590', name: 'Guadeloupe', countryCode: 'GP' },
    { dialCode: '590', name: 'Saint Barthelemy', countryCode: 'BL' },
    { dialCode: '590', name: 'Saint Martin', countryCode: 'MF' },
    { dialCode: '591', name: 'Bolivia', countryCode: 'BO' },
    { dialCode: '592', name: 'Guyana', countryCode: 'GY' },
    { dialCode: '593', name: 'Ecuador', countryCode: 'EC' },
    { dialCode: '594', name: 'French Guiana', countryCode: 'GF' },
    { dialCode: '595', name: 'Paraguay', countryCode: 'PY' },
    { dialCode: '596', name: 'Martinique', countryCode: 'MQ' },
    { dialCode: '597', name: 'Suriname', countryCode: 'SR' },
    { dialCode: '598', name: 'Uruguay', countryCode: 'UY' },
    { dialCode: '599', name: 'Bonaire, Sint Eustatius and Saba', countryCode: 'BQ' },
    { dialCode: '599', name: 'Curaçao', countryCode: 'CW' },
    { dialCode: '670', name: 'Timor-Leste', countryCode: 'TL' },
    { dialCode: '672', name: 'Norfolk Island', countryCode: 'NF' },
    { dialCode: '673', name: 'Brunei Darussalam', countryCode: 'BN' },
    { dialCode: '674', name: 'Nauru', countryCode: 'NR' },
    { dialCode: '675', name: 'Papua New Guinea', countryCode: 'PG' },
    { dialCode: '676', name: 'Tonga', countryCode: 'TO' },
    { dialCode: '677', name: 'Solomon Islands', countryCode: 'SB' },
    { dialCode: '678', name: 'Vanuatu', countryCode: 'VU' },
    { dialCode: '679', name: 'Fiji', countryCode: 'FJ' },
    { dialCode: '680', name: 'Palau', countryCode: 'PW' },
    { dialCode: '681', name: 'Wallis and Futuna', countryCode: 'WF' },
    { dialCode: '682', name: 'Cook Islands', countryCode: 'CK' },
    { dialCode: '683', name: 'Niue', countryCode: 'NU' },
    { dialCode: '685', name: 'Samoa', countryCode: 'WS' },
    { dialCode: '686', name: 'Kiribati', countryCode: 'KI' },
    { dialCode: '687', name: 'New Caledonia', countryCode: 'NC' },
    { dialCode: '688', name: 'Tuvalu', countryCode: 'TV' },
    { dialCode: '689', name: 'French Polynesia', countryCode: 'PF' },
    { dialCode: '690', name: 'Tokelau', countryCode: 'TK' },
    { dialCode: '691', name: 'Micronesia', countryCode: 'FM' },
    { dialCode: '692', name: 'Marshall Islands', countryCode: 'MH' },
    { dialCode: '850', name: 'Republic of Korea', countryCode: 'KR' },
    { dialCode: '852', name: 'Hong Kong', countryCode: 'HK' },
    { dialCode: '853', name: 'Macao', countryCode: 'MO' },
    { dialCode: '855', name: 'Cambodia', countryCode: 'KH' },
    { dialCode: '856', name: "Lao People's Democratic Republic", countryCode: 'LA' },
    { dialCode: '880', name: 'Bangladesh', countryCode: 'BD' },
    { dialCode: '886', name: 'Taiwan', countryCode: 'TW' },
    { dialCode: '960', name: 'Maldives', countryCode: 'MV' },
    { dialCode: '961', name: 'Lebanon', countryCode: 'LB' },
    { dialCode: '962', name: 'Jordan', countryCode: 'JO' },
    { dialCode: '963', name: 'Syrian Arab Republic', countryCode: 'SY' },
    { dialCode: '964', name: 'Iraq', countryCode: 'IQ' },
    { dialCode: '965', name: 'Kuwait', countryCode: 'KW' },
    { dialCode: '966', name: 'Saudi Arabia', countryCode: 'SA' },
    { dialCode: '967', name: 'Yemen', countryCode: 'YE' },
    { dialCode: '968', name: 'Oman', countryCode: 'OM' },
    { dialCode: '970', name: 'State of Palestine', countryCode: 'PS' },
    { dialCode: '971', name: 'United Arab Emirates', countryCode: 'AE' },
    { dialCode: '972', name: 'Israel', countryCode: 'IL' },
    { dialCode: '973', name: 'Bahrain', countryCode: 'BH' },
    { dialCode: '974', name: 'Qatar', countryCode: 'QA' },
    { dialCode: '975', name: 'Bhutan', countryCode: 'BT' },
    { dialCode: '976', name: 'Mongolia', countryCode: 'MN' },
    { dialCode: '977', name: 'Nepal', countryCode: 'NP' },
    { dialCode: '992', name: 'Tajikistan', countryCode: 'TJ' },
    { dialCode: '993', name: 'Turkmenistan', countryCode: 'TM' },
    { dialCode: '994', name: 'Azerbaijan', countryCode: 'AZ' },
    { dialCode: '995', name: 'Georgia', countryCode: 'GE' },
    { dialCode: '996', name: 'Kyrgyzstan', countryCode: 'KG' },
    { dialCode: '998', name: 'Uzbekistan', countryCode: 'UZ' }
];
